import { getLanguageBaseOnTZ } from '../../../../utils/LanguageLocalStorage';

export default {
  confirmCloseMember: 'ایا مطمئن هستید که صفحه بسته شود',
  name: 'نام و نام خانوادگی کاربر',
  save: 'ذخیره',
  phoneNumber: 'شماره تلفن همراه',
  roles: 'سمت‌های اصلی کاربر',
  otherRoles: 'سایر سمت‌ها',
  memberInfo: 'اطلاعات کاربر',
  projects: 'پروژه‌ها',
  changeLog: 'تاریخچه تغییرات',
  disable: 'غیرفعال کردن کاربر',
  specifyDistrict:
    'لطفا بخش محل فعالیت کاربر را مشخص کنید (در بخش سمت‌ها، سمت‌هایی که با پرسنل شروع می‌شوند)',
  admin: 'دسترسی مدیریت کاربران',
  specifyPost: 'لطفا سمت کاربر را مشخص کنید',
  mainUser: 'کاربر اصلی',
  implictUser: 'کاربر ضمنی',
  implicitDesc: 'عضویت کاربر به دلیل محول شدن وظیفه در پروژه‌ (عضو ضمنی)',
  projectName: 'عنوان پروژه',
  relatedrole: 'سمت مرتبط',
  projectRole: 'سمت در پروژه',
  memberType: 'نوع عضویت',
  nameHint:
    'لطفا نام به صورت کامل و در صورت وجود با پیشوند و پسوند نوشته شود. همچنین برای پزشکان از پیشوند دکتر استفاده نمایید ',
  shownAfterSave:
    'سایر سمت‌ها پس از ذخیره سازی و اعمال تغییرات  نمایش داده می‌شوند',
  other: 'سایر',
  selfUser: 'توسط خود کاربر',
  action: 'عملیات',
  date: 'تاریخ',
  otherDesc: 'توضیحات',
  actor: 'کاربر عامل',
  errorLoadingMemberLogs: 'خطا در دریافت تاریخچه تغییرات کاربر',
  unauthorizedChangeUserPhone:
    'شما دسترسی تغییر شماره تلفن این کاربر را ندارید، در صورت نیاز لطفا با پشتیبانی تماس بگیرید',
  UpdateName: 'تغییر نام',
  UpdatePhone: 'تغییر تلفن',
  AddRole: 'افزودن نقش / سمت',
  RemoveRole: 'حذف نقش / سمت ',
  AddedToCompany: 'افزودن به سازمان',
  RemovedFromCompany: 'حذف از سازمان',
  restore: 'باز فعال سازی کاربر',
  employeeId: 'کد پرسنلی',

  fromTo(oldValue: string, newValue: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa') return `از ${oldValue} به ${newValue}`;
    else return `From ${oldValue} to ${newValue}`;
  },

  deleteUserFromCompany(memberName: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa')
      return `${memberName} از لیست کاربران حذف شود؟ با این کار عضویت فرد در تمام پروژه ها لغو خواهد شد، همه سمت‌ها از کاربر گرفته می‌شود و همه دسترسی های کاربر حذف می‌شود. `;
    else
      return `Should ${memberName} be removed from the user list? This will revoke the user's membership in all projects, remove all roles from the user, and delete all user permissions.`;
  },
  restoreUserInCompany(memberName: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa') return `${memberName} دوباره فعال شود؟`;
    else return `Are you sure you want to active ${memberName}?`;
  },
  memberRemoved(memberName: string) {
    const lang = getLanguageBaseOnTZ();
    if (lang === 'fa') return `${memberName} با موفقیت از شرکت حذف شد`;
    else return `${memberName} deleted successfully`;
  },
};
